import { render } from "./BaseButton.vue?vue&type=template&id=5ed81b12&scoped=true&bindings={\"title\":\"props\",\"mode\":\"props\"}"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=5ed81b12&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5ed81b12"

export default script